import request from '@/utils/request'
import Custom from './custom'
export default {
    async bookSearch (params = {}) {
        if (params.pinyinIndex) {
            params.pinyinIndex = String(params.pinyinIndex).toLowerCase()
        }
        let res = await request.get('/bookMetaData/select', { params })
        return res.data
    },
    async selectCount (params = {}) {
        if (params.pinyinIndex) {
            params.pinyinIndex = String(params.pinyinIndex).toLowerCase()
        }
        let res = await request.get('/bookMetaData/selectCount', { params })
        return res.data
    },

    async selectCountBySourceId (params = {}) {
        let res = await request.get('/bookMetaData/selectCountBySourceId', { params })
        return res.data
    },

    async selectResouorceHeatData (params = {}) {
        let res = await request.get('/resourceHeats/select', { params })
        return res.data
    },
    async selectByBookIds (params = {}) {
        let res = await request.get('/bookMetaData/selectByBookIds', { params })
        return res.data
    },
    async addClickRecord (params = {}) {
        let res = await request.post('/bookMetaData/addClickRecord', params)
        return res.data
    },
    async getPagesBySourceId (sourceId) {
        let api = new Custom('structureMetaData')
        let res = await api.getRecords({
            pageIndex: 1,
            pageSize: 999,
            sourceId: sourceId
        })
        let rows = res.rows
        return Number(rows[rows.length - 1].endFileName)
    },
    async selectSearchKeywords (params = {}) {
        let res = await request.get('/searchKeywords/select', { params })
        return res.data
    },
    async selectWordCloud (params = {}) {
        let res = await request.get('/wordClouds/select', { params })
        return res.data
    },
    async selectKnowledgeGraph (params = {}) {
        let res = await request.get('/knowledgeGraph/select', { params })
        return res.data
    },
    async getIndexDataRowNumber (params = {}) {
        let res = await request.get('/bookMetaData/getIndexDataRowNumber', { params })
        return res.data
    },
    // 获取结构数据
    async getStructures (params) {
        let res = await request.get('/bookStructureData/select', { params })
        return res.data
    },
    // 获取卷目数据
    async getVolumeData (params) {
        let res = await request.get('/bookVolumeData/select', { params })
        return res.data
    },
    // 四部分类统计
    async selectFDCStatis (params = {}) {
        let res = await request.get('/bookMetaData/selectFDCStatis', { params })
        return res.data
    },
    // 书籍结构统计
    async selectBookStructureStatis (params = {}) {
        let res = await request.get('/bookMetaData/selectBookStructureStatis', { params })
        return res.data
    }
 }
